module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Fetigny_COA-a23bcfe4e6bfdcd5936c3d4150f85c07.svg";